var map = {
	"./A01/A01_B00/A01_B00_CA01": "WlBS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cHSN";


//////////////////
// WEBPACK FOOTER
// ./src/router (\d{2})$
// module id = cHSN
// module chunks = 9